import { useMemo } from "react";
import { buildCoordPassSet, getActiveGlobalParams, hasActiveFilter } from "../utils/filterUtils";
import { ParamFilterState } from "../pages/home/heat-map/GlobalFilter";
import { Network } from "../components/InterfaceInfo";

type LatLngKey = string;

export function useCoordPassSet(args: {
  network?: Network | null;
  savedGlobalParams: any;
  storedLocationParams: any;
  paramFilter: ParamFilterState;
  networkId: string
}) {
  const { network, savedGlobalParams, storedLocationParams, paramFilter, networkId } = args;

  const allCoordKeys: LatLngKey[] = useMemo(() => {
    if (!network?.edgesOfNetwork) return [];
    const keys: string[] = [];

    network.edgesOfNetwork.forEach((edge) => {
      edge.lineString.coordinates.forEach(([lng, lat]: [any, any]) => {
        keys.push(`${lat},${lng}`);
      });
    });

    return keys;
  }, [network?.edgesOfNetwork]);

  const globalParams = useMemo(
    () => getActiveGlobalParams(savedGlobalParams, networkId),
    [savedGlobalParams]
  );

  // depend on the whole paramFilter object (groups/logic),
  // not paramFilter.rows (doesn't exist anymore)
  const coordPassSet = useMemo(() => {
    if (!hasActiveFilter(paramFilter)) return null as Set<string> | null;

    return buildCoordPassSet(
      allCoordKeys,
      storedLocationParams,
      globalParams,
      paramFilter
    );
  }, [allCoordKeys, storedLocationParams, globalParams, paramFilter]);

  return { allCoordKeys, globalParams, coordPassSet };
}